import React, { useState } from "react";
import CustomModal from "./CustomModal";
import AuthInput from "../Input/AuthInput";
import { useDispatch, useSelector } from "react-redux";
import AddingLightLoader from "../Loaders/AddingLightLoader";
import { ErrorToast, SuccessToast, WarningToast } from "../../utils/ShowToast";
import {
  CreateCustomerApi,
  CreateLabourApi,
  EditLabourApi,
} from "../../ApiRequests"; // Updated API function
import AuthBtn from "../Buttons/AuthBtn";
import { fetchCustomers } from "../../store/Slices/CustomerSlice";
import { fetchLabours } from "../../store/Slices/LabourSlice";

const EditLabourModal = ({ Open, setOpen, currentLabour }) => {
  const [Name, setName] = useState(currentLabour?.name || "");
  const [Contact, setContact] = useState(currentLabour?.contact || "");
  const [Address, setAddress] = useState(currentLabour?.address || "");
  const [Email, setEmail] = useState(""); // Added Email state
  const [sallary, setSallary] = useState(currentLabour.salary || 0);
  const [Loading, setLoading] = useState(false);

  const dispatch = useDispatch();

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    if (Name === "") {
      WarningToast("Enter a valid name");
    } else if (Contact === "") {
      WarningToast("Enter a valid contact number");
    } else if (Address === "") {
      WarningToast("Enter a valid address");
    } else {
      try {
        const response = await EditLabourApi(currentLabour._id, {
          name: Name,
          contact: Contact,
          address: Address,
          // email: Email, // Added Email to API request
          salary: sallary,
        });
        if (response.data.success) {
          setOpen(false);
          SuccessToast("Labour added successfully");
          dispatch(fetchLabours());
        } else {
          ErrorToast(response.data.error?.msg);
        }
      } catch (err) {
        console.log(err);
        ErrorToast("Failed to add labour");
      }
    }
    setLoading(false);
  };

  return (
    <CustomModal open={Open} setOpen={setOpen}>
      <div className="pb-8">
        <h1 className="w-full text-center font-[700] text-3xl py-8">
          Update Labour
        </h1>
        <div className="flex flex-col px-10 gap-y-4">
          <AuthInput
            label="Name"
            placeholder="Enter Name"
            Value={Name}
            setValue={setName}
          />
          <AuthInput
            label="Contact"
            placeholder="Enter Contact"
            Value={Contact}
            setValue={setContact}
          />
          <AuthInput
            label="Address"
            placeholder="Enter Address"
            Value={Address}
            setValue={setAddress}
          />
          {/* <AuthInput
            label="Email"
            placeholder="Enter Email"
            Value={Email}
            setValue={setEmail}
          /> */}
          <AuthInput
            label="Sallary"
            placeholder="Enter Sallary"
            Value={sallary}
            setValue={setSallary}
          />
        </div>
        <div className="flex justify-center items-center gap-x-2 mt-5 px-5">
          {Loading ? (
            <AddingLightLoader />
          ) : (
            <>
              <AuthBtn title={"Update Labour"} onSubmit={onSubmit} type={1} />
              <AuthBtn
                title={"Cancel"}
                onSubmit={() => setOpen(false)}
                type={2}
              />
            </>
          )}
        </div>
      </div>
    </CustomModal>
  );
};

export default EditLabourModal;
